export default __webpack_public_path__ + "static/media/vs.a5212ba3.JPG";